import UltMeta, { Meta } from "./UltMeta";

/**
 * 启用状态
 */
class Able extends UltMeta {
    ENABLE = new Meta(1, "已启用");
    DISABLE = new Meta(0, "已禁用", "color-info");
}

/**
 * 同步状态
 */
class Aynchronization extends UltMeta {
    ALREDY = new Meta(1, "已同步");
    NOT = new Meta(0, "未同步");
}

/**上架状态 */
class Shelf extends UltMeta {
    SHELF = new Meta(1, "已上架");
    REMOVE_SHELF = new Meta(0, "已下架", "color-info");
}

/**
 * 排序
 */
class Sort extends UltMeta {
    ASC = new Meta("ascending", "asc", 1);
    DESC = new Meta("descending", "desc", 0);
}
export const ABLE = new Able();
export const AYNCHRONIZATION = new Aynchronization();
export const SORT = new Sort();
export const SHELF = new Shelf();

class FileTemplate extends UltMeta {
    PRODUCT_TYPE_INDEX = new Meta(1, "productTypeIndex.xlsx");
}
export const FILE_TEMPLATE = new FileTemplate();

/**
 * 页面类型
 */
class PageType extends UltMeta {
    LIST = new Meta(0, "列表");
    DETAIL = new Meta(1, "详情");
    LOG = new Meta(2, "记录");
    /**
     * 缓存表单页
     * 缓存的表单页提交成功后要调用 keepAliveStore.deleteCacheForm() 来删除缓存
     **/
    CACHE_FORM = new Meta(3, "表单");
}
export const PAGE_TYPE = new PageType();

/**
 * 排行版类型
 */
class RankListType extends UltMeta {
    ROUTE = new Meta(1, "航线");
    PORT = new Meta(2, "港口");
}
export const RANK_LIST_TYPE = new RankListType();

/**
 * 主题色
 */
class ThemeColor extends UltMeta {
    Primary = new Meta("primary", "#3370FF");
    // Error = new Meta("error", "#F96666");
    // Success = new Meta("success", "#41C2C9");
    Info = new Meta("info", "#999999");
    // Warning = new Meta("warning", "#F7AC46");
}
export const THEME_COLOR = new ThemeColor();

class WebSocketReadyState extends UltMeta {
    CONNECTING = new Meta(0, "正在链接中");
    OPEN = new Meta(1, "已经链接并且可以通讯");
    CLOSING = new Meta(2, "连接正在关闭");
    CLOSED = new Meta(3, "连接已关闭或者没有链接成功");
}
export const WEBSOCKET_READY_STATE = new WebSocketReadyState();

class YesOrNo extends UltMeta {
    YES = new Meta(1, "是");
    NO = new Meta(0, "否");
}
export const YES_OR_NO = new YesOrNo();

/**
 * 企业类型
 */
class EnterpriseType extends UltMeta {
    REGISTERED = new Meta(1, "注册企业");
    ENTER = new Meta(2, "录入企业");
}

export const ENTERPRISE_TYPE = new EnterpriseType();

class EnterpriseState extends UltMeta {
    CONFIRMING = new Meta(1, "确认中");
    TO_BE_CONFIRMED = new Meta(2, "待确认");
    COOPERATION = new Meta(3, "合作中");
    REJECTED = new Meta(4, "已驳回");
}

export const ENTERPRISE_STATE = new EnterpriseState();
